/**
 * @generated SignedSource<<be868ca3a0ff417e7f352f4147ac02b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FundDirectoryRows_allCompanies$data = {
  readonly allCompanies: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"RowFund_fund">;
      } | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "FundDirectoryRows_allCompanies";
};
export type FundDirectoryRows_allCompanies$key = {
  readonly " $data"?: FundDirectoryRows_allCompanies$data;
  readonly " $fragmentSpreads": FragmentRefs<"FundDirectoryRows_allCompanies">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "allCompanies"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "displayName_Icontains"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "genres"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "onlyWatching"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "onlyWithTestimonials"
    },
    {
      "defaultValue": "total_streams_desc",
      "kind": "LocalArgument",
      "name": "orderBy"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "services"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./FundDirectoryPaginationQuery.graphql')
    }
  },
  "name": "FundDirectoryRows_allCompanies",
  "selections": [
    {
      "alias": "allCompanies",
      "args": [
        {
          "kind": "Variable",
          "name": "displayName_Icontains",
          "variableName": "displayName_Icontains"
        },
        {
          "kind": "Variable",
          "name": "genres",
          "variableName": "genres"
        },
        {
          "kind": "Variable",
          "name": "onlyWatching",
          "variableName": "onlyWatching"
        },
        {
          "kind": "Variable",
          "name": "onlyWithTestimonials",
          "variableName": "onlyWithTestimonials"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        },
        {
          "kind": "Variable",
          "name": "services",
          "variableName": "services"
        }
      ],
      "concreteType": "CompanyNodeConnection",
      "kind": "LinkedField",
      "name": "__FundDirectory_allCompanies_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RowFund_fund"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "f8a304cf26125288cf82f5e5449e3ebd";

export default node;
